module.exports = __webpack_public_path__ + "img/Dive.8c6dc201.png";